import { mapActions } from 'vuex';
import { MODALS } from '@/components/app/app-modals/app-modals';
import popupPageModeMixin from '@/mixins/popupPageModeMixin';

export default {
  mixins: [
    popupPageModeMixin,
  ],
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    onLogin() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'click',
        label: 'Login to My Account',
      });
      if (this.isPage) {
        this.$router.push({ name: 'account-page-login' });
      } else {
        this.setCurrentPopup(MODALS.LOGIN);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-enable-classic-predictit/footer/footer.js